import React, { useContext ,useState} from 'react';
import { MentionsInput, Mention } from "react-mentions";
// import MentionWrapperStyle from "./MentionWrapperStyle";
import Avatar from 'react-avatar';
import './InternalNotes.scss';
import {  mentionsUsers } from '../../../models/SharedModel';
import Service from '../../../services';
import { AxiosError } from 'axios';
import { catchError } from '../../../utils/Utils';
import { BankUserContext } from '../../../bankUserContext';
import { useParams } from 'react-router';

interface InternalNotesProps{
  usersData:mentionsUsers[];
  getInternalNotes:Function;
}

const InternalNotesFC=(props:InternalNotesProps)=> {
    const [textAreaVal, setTextAreaVal] = React.useState("");
    const [mentionsData,setMentionsData] = useState<any>([])
    const service=new Service();
    const context =useContext(BankUserContext);
    const {clientProductsId}=useParams();

 const saveComment = (event: any) => {
  const keyCode = event.keyCode || event.which;
  if(keyCode==13 && textAreaVal.trim() !== ""){
    event.preventDefault();
    const requestObj = {
      screen: "LandingPage",  
      sections: "ClientComment",  
      data: {  
          userIds: JSON.stringify(mentionsData),  
          comments: textAreaVal,  
          clientProductId: clientProductsId,  
          commentStatus: "Active",  
          createdBy: context.bankuserDetails?.userId 
      }  
  }
  
    if (textAreaVal !== "") {
    service.saveInternalNotes(requestObj)
    .then(() => {
      props.getInternalNotes();     
    }).catch((error: AxiosError) => {
      catchError(error,true)       
    });
    }
  setMentionsData([]);
  setTextAreaVal("");
  }
 
}

const handleOnChange=(e:any,newValue:any, newPlainTextValue:any, mentions:any)=>{  
      setTextAreaVal(e.target.value);    
}

const addSuggestedUsers = (id: any) => {
  if (!mentionsData?.includes(id)) {
    setMentionsData([...mentionsData, id])
  }
}


return (
    <div className='NotesContainer'>
      <div>
      <Avatar name={`${context.bankuserDetails?.firstName} ${context.bankuserDetails?.lastName}`}  className="avatar"/>
      </div>
      
      <MentionsInput
        value={textAreaVal}
        onChange={(e:any,newValue, newPlainTextValue, mentions) => handleOnChange(e,newValue, newPlainTextValue, mentions)}
        className={"mentionInput"}
        onKeyDown={saveComment}
        placeholder={"Add a Comment"}
      >
        <Mention data={props.usersData} trigger={"@"}
          onAdd={addSuggestedUsers}
        />
      </MentionsInput>
    </div>
  )
}

export default InternalNotesFC